<template>
  <div>
    <Subheader title="Post an Update" />

    <div class="app-content-column">
      <div class="card">
        <form class="form" @submit.stop.prevent="submitUpdate">
          <h5>Update Title</h5>
          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="title">
            <input v-model="updateData.title" class="input" type="text" required />
          </Field>

          <h5>Update Text</h5>
          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="text">
            <textarea v-model="updateData.text" class="textarea" cols="30" rows="10" required />
          </Field>

          <h5>Upload Photos</h5>
          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="photo">
            <input ref="resultFiles" type="file" @change="previewFiles" />
          </Field>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button" :disabled="loading">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Field from '@/components/Field'

import Update from '@/services/updates'
import Photo from '@/services/photos'
import { validateInputLength } from '@/services/forms'
import { errorMessage } from '@/services/utils/apiErrors'

import moment from 'moment'

export default {
  name: 'NewUpdate',
  components: {
    Subheader,
    Field,
  },
  data() {
    return {
      photo: null,
      loading: false,
      updateData: {
        title: '',
        text: '',
      },
      fieldErrors: [],
      showFieldErrors: false,
    }
  },
  methods: {
    previewFiles(event) {
      this.photo = event.target.files[0]
    },
    async submitUpdate() {
      this.loading = true
      this.fieldErrors = []
      this.fieldErrors = this.collectFieldErrors()
      try {
        if (this.fieldErrors.length) {
          this.showFieldErrors = true
        } else {
          const newUpdate = Update.create({
            title: this.updateData.title,
            description: this.updateData.text,
            date: moment().toISOString(),
            project: this.$route.params.projectId,
          })

          Update.api.create(newUpdate).then(data => {
            // This is a little ugly to chain these calls, I think we should use multi-part form data down the road
            // I need to do this because I need the update ID from the server to link the photo to it.
            if (this.photo) {
              Photo.api.createPhotoWithUpdate(data.id, this.photo).then(() => {
                this.alertSuccessAndRoute()
              })
            } else {
              this.alertSuccessAndRoute()
            }
          })
        }
      } catch {
        errorMessage()
      } finally {
        this.loading = false
      }
    },
    alertSuccessAndRoute() {
      this.$Alert.alert({
        type: 'success',
        message: `<h2>Update Submitted</h2>`,
        timeout: 3000,
      })
      this.$router.push({ name: 'Project' })
    },
    collectFieldErrors() {
      //client-side validation
      const errors = []

      Object.keys(this.updateData).forEach(field => {
        const error = validateInputLength(field, this.updateData[field])
        if (error) {
          errors.push(error)
        }
      })

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/layout';
@import '../styles/forms';

.card {
  @include card-w-borders();
}
</style>
